import bootstrap from '@/bootstrap';
import { BluetoothSDK } from '@/utils/BluetoothSDK.js';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import { createApp } from 'vue';
import VueWechatTitle from 'vue-wechat-title'; //动态修改title
import '../static/css/animation.css';
import '../static/css/common.css';
import '../static/css/font.css';
import '../static/css/style.css';
import App from './App.vue';
import i18n from './language/i18n';
import router from './router';
import { axios, axioshanma, axiosnet, qiniuApi } from './services/axios';
import store from './store';

const app = createApp(App);
app.config.globalProperties.$axios = axios;
app.config.globalProperties.$axioshanma = axioshanma;
app.config.globalProperties.$axiosnet = axiosnet;
app.config.globalProperties.$qiniuApi = qiniuApi;
app.config.globalProperties.$unit = localStorage.getItem('measureUnit') ? localStorage.getItem('measureUnit') : 'mm';
app.config.globalProperties.$largerSize = 5.5; //文件可打开编辑的最大size
app.config.globalProperties.$upload = `${process.env.VUE_APP_VERSION == 'hprt' || process.env.VUE_APP_VERSION == 'electron' ? 'https://upload-z2.qiniup.com/' : 'https://up-na0.qiniup.com/'}`;
app.config.globalProperties.$picupload = `${app.config.globalProperties.$upload}putb64/-1/key/`;
//存在对Electron应用的特殊处理
if (process.env.VUE_APP_VERSION == 'electron') {
	const bluetoothSDK = new BluetoothSDK();
	if (BluetoothSDK.isBluetoothAvailable()) {
		console.log('当前支持蓝牙');
	} else {
		console.log('当前不支持蓝牙');
	}
	app.config.globalProperties.$bluetoothSDK = bluetoothSDK;
	app.config.globalProperties.$Version = 'Label Designer V2.6.3'; //版本号
	app.config.globalProperties.$qiniuAction = 'https://upload-z2.qiniup.com/';
}

bootstrap({ router, store });
app.use(store);
app.use(ElementPlus);
app.use(router);
app.use(Antd);
app.use(i18n);

app.use(VueWechatTitle);
app.mount('#app');
